export enum LineItemComparisonIndicator {
    DIFFERENT_PRODUCT = 'differentProduct',
    EQUIVALENT_PRODUCT = 'equivalentProduct',
}
